//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param documentTypeId (optional) 
     * @param categoryId (optional) 
     * @param companyId (optional) 
     * @param productId (optional) 
     * @param title (optional) 
     * @param isIncludeInactiveCarrier (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllAdminDocument(v: string, documentTypeId?: number | null | undefined, categoryId?: number | null | undefined, companyId?: number | null | undefined, productId?: number | null | undefined, title?: string | null | undefined, isIncludeInactiveCarrier?: boolean | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentsSearchResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managedocuments?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (documentTypeId !== undefined && documentTypeId !== null)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (productId !== undefined && productId !== null)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (title !== undefined && title !== null)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (isIncludeInactiveCarrier === null)
            throw new Error("The parameter 'isIncludeInactiveCarrier' cannot be null.");
        else if (isIncludeInactiveCarrier !== undefined)
            url_ += "IsIncludeInactiveCarrier=" + encodeURIComponent("" + isIncludeInactiveCarrier) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAdminDocument(_response);
        });
    }

    protected processGetAllAdminDocument(response: Response): Promise<DocumentsSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentsSearchResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentsSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param id (optional) 
     * @param title (optional) 
     * @param description (optional) 
     * @param documentTypeId (optional) 
     * @param companyId (optional) 
     * @param productId (optional) 
     * @param fileName (optional) 
     * @param dateCreated (optional) 
     * @param createUserId (optional) 
     * @param masterDocId (optional) 
     * @param file (optional) 
     * @param showOnAgentPortal (optional) 
     * @param agentPortalPageID (optional) 
     * @param agentPortalYear (optional) 
     * @return Success
     */
    createAdminDocument(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, id?: number | undefined, title?: string | null | undefined, description?: string | null | undefined, documentTypeId?: number | undefined, companyId?: number | undefined, productId?: number | undefined, fileName?: string | null | undefined, dateCreated?: number | undefined, createUserId?: number | undefined, masterDocId?: number | undefined, file?: FileParameter | null | undefined, showOnAgentPortal?: boolean | undefined, agentPortalPageID?: number | null | undefined, agentPortalYear?: number | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managedocuments";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (documentTypeId === null || documentTypeId === undefined)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else
            content_.append("DocumentTypeId", documentTypeId.toString());
        if (companyId === null || companyId === undefined)
            throw new Error("The parameter 'companyId' cannot be null.");
        else
            content_.append("CompanyId", companyId.toString());
        if (productId === null || productId === undefined)
            throw new Error("The parameter 'productId' cannot be null.");
        else
            content_.append("ProductId", productId.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());
        if (dateCreated === null || dateCreated === undefined)
            throw new Error("The parameter 'dateCreated' cannot be null.");
        else
            content_.append("DateCreated", dateCreated.toString());
        if (createUserId === null || createUserId === undefined)
            throw new Error("The parameter 'createUserId' cannot be null.");
        else
            content_.append("CreateUserId", createUserId.toString());
        if (masterDocId === null || masterDocId === undefined)
            throw new Error("The parameter 'masterDocId' cannot be null.");
        else
            content_.append("MasterDocId", masterDocId.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (showOnAgentPortal === null || showOnAgentPortal === undefined)
            throw new Error("The parameter 'showOnAgentPortal' cannot be null.");
        else
            content_.append("ShowOnAgentPortal", showOnAgentPortal.toString());
        if (agentPortalPageID !== null && agentPortalPageID !== undefined)
            content_.append("AgentPortalPageID", agentPortalPageID.toString());
        if (agentPortalYear !== null && agentPortalYear !== undefined)
            content_.append("AgentPortalYear", agentPortalYear.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAdminDocument(_response);
        });
    }

    protected processCreateAdminDocument(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
                return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param id (optional) 
     * @param title (optional) 
     * @param description (optional) 
     * @param documentTypeId (optional) 
     * @param companyId (optional) 
     * @param productId (optional) 
     * @param fileName (optional) 
     * @param dateCreated (optional) 
     * @param createUserId (optional) 
     * @param masterDocId (optional) 
     * @param file (optional) 
     * @param showOnAgentPortal (optional) 
     * @param agentPortalPageID (optional) 
     * @param agentPortalYear (optional) 
     * @return Success
     */
    updateAdminDocument(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, id?: number | undefined, title?: string | null | undefined, description?: string | null | undefined, documentTypeId?: number | undefined, companyId?: number | undefined, productId?: number | undefined, fileName?: string | null | undefined, dateCreated?: number | undefined, createUserId?: number | undefined, masterDocId?: number | undefined, file?: FileParameter | null | undefined, showOnAgentPortal?: boolean | undefined, agentPortalPageID?: number | null | undefined, agentPortalYear?: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managedocuments";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (documentTypeId === null || documentTypeId === undefined)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else
            content_.append("DocumentTypeId", documentTypeId.toString());
        if (companyId === null || companyId === undefined)
            throw new Error("The parameter 'companyId' cannot be null.");
        else
            content_.append("CompanyId", companyId.toString());
        if (productId === null || productId === undefined)
            throw new Error("The parameter 'productId' cannot be null.");
        else
            content_.append("ProductId", productId.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());
        if (dateCreated === null || dateCreated === undefined)
            throw new Error("The parameter 'dateCreated' cannot be null.");
        else
            content_.append("DateCreated", dateCreated.toString());
        if (createUserId === null || createUserId === undefined)
            throw new Error("The parameter 'createUserId' cannot be null.");
        else
            content_.append("CreateUserId", createUserId.toString());
        if (masterDocId === null || masterDocId === undefined)
            throw new Error("The parameter 'masterDocId' cannot be null.");
        else
            content_.append("MasterDocId", masterDocId.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (showOnAgentPortal === null || showOnAgentPortal === undefined)
            throw new Error("The parameter 'showOnAgentPortal' cannot be null.");
        else
            content_.append("ShowOnAgentPortal", showOnAgentPortal.toString());
        if (agentPortalPageID !== null && agentPortalPageID !== undefined)
            content_.append("AgentPortalPageID", agentPortalPageID.toString());
        if (agentPortalYear !== null && agentPortalYear !== undefined)
            content_.append("AgentPortalYear", agentPortalYear.toString());

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAdminDocument(_response);
        });
    }

    protected processUpdateAdminDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAdminDocumentById(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentByIdResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managedocuments/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAdminDocumentById(_response);
        });
    }

    protected processGetAdminDocumentById(response: Response): Promise<DocumentByIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentByIdResponse;
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param id (optional) 
     * @param title (optional) 
     * @param description (optional) 
     * @param documentTypeId (optional) 
     * @param companyId (optional) 
     * @param productId (optional) 
     * @param fileName (optional) 
     * @param dateCreated (optional) 
     * @param createUserId (optional) 
     * @param masterDocId (optional) 
     * @param file (optional) 
     * @param showOnAgentPortal (optional) 
     * @param agentPortalPageID (optional) 
     * @param agentPortalYear (optional) 
     * @return Success
     */
    uploadAdminDocument(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, id?: number | undefined, title?: string | null | undefined, description?: string | null | undefined, documentTypeId?: number | undefined, companyId?: number | undefined, productId?: number | undefined, fileName?: string | null | undefined, dateCreated?: number | undefined, createUserId?: number | undefined, masterDocId?: number | undefined, file?: FileParameter | null | undefined, showOnAgentPortal?: boolean | undefined, agentPortalPageID?: number | null | undefined, agentPortalYear?: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managedocuments/upload";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (documentTypeId === null || documentTypeId === undefined)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else
            content_.append("DocumentTypeId", documentTypeId.toString());
        if (companyId === null || companyId === undefined)
            throw new Error("The parameter 'companyId' cannot be null.");
        else
            content_.append("CompanyId", companyId.toString());
        if (productId === null || productId === undefined)
            throw new Error("The parameter 'productId' cannot be null.");
        else
            content_.append("ProductId", productId.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());
        if (dateCreated === null || dateCreated === undefined)
            throw new Error("The parameter 'dateCreated' cannot be null.");
        else
            content_.append("DateCreated", dateCreated.toString());
        if (createUserId === null || createUserId === undefined)
            throw new Error("The parameter 'createUserId' cannot be null.");
        else
            content_.append("CreateUserId", createUserId.toString());
        if (masterDocId === null || masterDocId === undefined)
            throw new Error("The parameter 'masterDocId' cannot be null.");
        else
            content_.append("MasterDocId", masterDocId.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (showOnAgentPortal === null || showOnAgentPortal === undefined)
            throw new Error("The parameter 'showOnAgentPortal' cannot be null.");
        else
            content_.append("ShowOnAgentPortal", showOnAgentPortal.toString());
        if (agentPortalPageID !== null && agentPortalPageID !== undefined)
            content_.append("AgentPortalPageID", agentPortalPageID.toString());
        if (agentPortalYear !== null && agentPortalYear !== undefined)
            content_.append("AgentPortalYear", agentPortalYear.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadAdminDocument(_response);
        });
    }

    protected processUploadAdminDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    withDrawDocumentById(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managedocuments/{documentId}/withdraw";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithDrawDocumentById(_response);
        });
    }

    protected processWithDrawDocumentById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllAdminLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentsLookupModel> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managedocuments/lookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAdminLookup(_response);
        });
    }

    protected processGetAllAdminLookup(response: Response): Promise<DocumentsLookupModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentsLookupModel;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentsLookupModel>(null as any);
    }

    /**
     * @param documentId (optional) 
     * @param companyId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllArchivedDocuments(v: string, documentId?: number | undefined, companyId?: number | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ArchivedDocumentResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managedocuments/archiveddocuments?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllArchivedDocuments(_response);
        });
    }

    protected processGetAllArchivedDocuments(response: Response): Promise<ArchivedDocumentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ArchivedDocumentResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArchivedDocumentResponse>(null as any);
    }

    /**
     * @param carrierId (optional) 
     * @param documentTypeId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllDocumentSearchByType(v: string, carrierId?: number | undefined, documentTypeId?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentsSearchByTypeResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managedocuments/GetAllDocumentSearchByType?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (carrierId === null)
            throw new Error("The parameter 'carrierId' cannot be null.");
        else if (carrierId !== undefined)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllDocumentSearchByType(_response);
        });
    }

    protected processGetAllDocumentSearchByType(response: Response): Promise<DocumentsSearchByTypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentsSearchByTypeResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentsSearchByTypeResponse>(null as any);
    }

    /**
     * @param documentTypeId (optional) 
     * @param carrierId (optional) 
     * @param description (optional) 
     * @param packetName (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllPackets(v: string, documentTypeId?: number | null | undefined, carrierId?: number | null | undefined, description?: string | null | undefined, packetName?: string | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PacketSearchResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managepackets?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (documentTypeId !== undefined && documentTypeId !== null)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (carrierId !== undefined && carrierId !== null)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (description !== undefined && description !== null)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (packetName !== undefined && packetName !== null)
            url_ += "PacketName=" + encodeURIComponent("" + packetName) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPackets(_response);
        });
    }

    protected processGetAllPackets(response: Response): Promise<PacketSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PacketSearchResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PacketSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createPacket(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdatePacketRequest | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managepackets";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePacket(_response);
        });
    }

    protected processCreatePacket(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
                return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updatePacket(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdatePacketRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managepackets";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePacket(_response);
        });
    }

    protected processUpdatePacket(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPacketById(packetId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PacketByIdResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managepackets/{packetId}";
        if (packetId === undefined || packetId === null)
            throw new Error("The parameter 'packetId' must be defined.");
        url_ = url_.replace("{packetId}", encodeURIComponent("" + packetId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPacketById(_response);
        });
    }

    protected processGetPacketById(response: Response): Promise<PacketByIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PacketByIdResponse;
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deletePacket(packetId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managepackets/{packetId}";
        if (packetId === undefined || packetId === null)
            throw new Error("The parameter 'packetId' must be defined.");
        url_ = url_.replace("{packetId}", encodeURIComponent("" + packetId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePacket(_response);
        });
    }

    protected processDeletePacket(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllPacketsLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PacketLookupModel> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managepackets/lookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPacketsLookup(_response);
        });
    }

    protected processGetAllPacketsLookup(response: Response): Promise<PacketLookupModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PacketLookupModel;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PacketLookupModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPacketDocumentById(packetId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PacketDocumentRespose> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managepackets/{packetId}/documents";
        if (packetId === undefined || packetId === null)
            throw new Error("The parameter 'packetId' must be defined.");
        url_ = url_.replace("{packetId}", encodeURIComponent("" + packetId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPacketDocumentById(_response);
        });
    }

    protected processGetPacketDocumentById(response: Response): Promise<PacketDocumentRespose> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PacketDocumentRespose;
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    duplicatePacket(packetId: number, packetName: string | null, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managepackets/{packetId}/duplicatepacket/{packetName}";
        if (packetId === undefined || packetId === null)
            throw new Error("The parameter 'packetId' must be defined.");
        url_ = url_.replace("{packetId}", encodeURIComponent("" + packetId));
        if (packetName === undefined || packetName === null)
            throw new Error("The parameter 'packetName' must be defined.");
        url_ = url_.replace("{packetName}", encodeURIComponent("" + packetName));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicatePacket(_response);
        });
    }

    protected processDuplicatePacket(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
                return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLookUpByCompany(packetId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<LookupByCompanyResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managepackets/{packetId}/companylookup";
        if (packetId === undefined || packetId === null)
            throw new Error("The parameter 'packetId' must be defined.");
        url_ = url_.replace("{packetId}", encodeURIComponent("" + packetId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLookUpByCompany(_response);
        });
    }

    protected processGetLookUpByCompany(response: Response): Promise<LookupByCompanyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookupByCompanyResponse;
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getProductsByCompany(packetId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managepackets/{packetId}/productsbycompany";
        if (packetId === undefined || packetId === null)
            throw new Error("The parameter 'packetId' must be defined.");
        url_ = url_.replace("{packetId}", encodeURIComponent("" + packetId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductsByCompany(_response);
        });
    }

    protected processGetProductsByCompany(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param categoryId (optional) 
     * @param carrierId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllPacketsSearchByCompany(v: string, categoryId?: number | null | undefined, carrierId?: number | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentsSearchByTypeResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/admin/managepackets/GetAllPacketsSearchByCompany?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (categoryId !== undefined && categoryId !== null)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (carrierId !== undefined && carrierId !== null)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPacketsSearchByCompany(_response);
        });
    }

    protected processGetAllPacketsSearchByCompany(response: Response): Promise<DocumentsSearchByTypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentsSearchByTypeResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentsSearchByTypeResponse>(null as any);
    }

    /**
     * @param documentTypeId (optional) 
     * @param companyId (optional) 
     * @param searchText (optional) 
     * @param status (optional) 
     * @param isIncludeInactiveCarrier (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllDocument(agentId: number, v: string, documentTypeId?: number | null | undefined, companyId?: number | null | undefined, searchText?: string | null | undefined, status?: boolean | null | undefined, isIncludeInactiveCarrier?: boolean | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentSearchRepsonse> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/agents/{agentId}?";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (documentTypeId !== undefined && documentTypeId !== null)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (isIncludeInactiveCarrier === null)
            throw new Error("The parameter 'isIncludeInactiveCarrier' cannot be null.");
        else if (isIncludeInactiveCarrier !== undefined)
            url_ += "IsIncludeInactiveCarrier=" + encodeURIComponent("" + isIncludeInactiveCarrier) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllDocument(_response);
        });
    }

    protected processGetAllDocument(response: Response): Promise<DocumentSearchRepsonse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentSearchRepsonse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentSearchRepsonse>(null as any);
    }

    /**
     * @param agentId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getDocumentById(id: number, v: string, agentId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentDetailModel> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocumentById(_response);
        });
    }

    protected processGetDocumentById(response: Response): Promise<DocumentDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentDetailModel;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDetailModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteDocument(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDocument(_response);
        });
    }

    protected processDeleteDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCustomerDocument(customerId: number, v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CustomerDocumentSearchResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/customers/{customerId}?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCustomerDocument(_response);
        });
    }

    protected processGetAllCustomerDocument(response: Response): Promise<CustomerDocumentSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerDocumentSearchResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerDocumentSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param id (optional) 
     * @param fName (optional) 
     * @param lName (optional) 
     * @param agentId (optional) 
     * @param typeId (optional) 
     * @param companyId (optional) 
     * @param marketerAgentId (optional) 
     * @param notes (optional) 
     * @param isPrivate (optional) 
     * @param createdDate (optional) 
     * @param fileData (optional) 
     * @param workflowStatusId (optional) 
     * @param licenseStatusId (optional) 
     * @param isWorkflowChecked (optional) 
     * @param isDontSend (optional) 
     * @param ignoreForAgeCalculation (optional) 
     * @param file (optional) 
     * @param isSendSubmission (optional) 
     * @param submissionTypeIds (optional) 
     * @return Success
     */
    createDocument(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, id?: number | undefined, fName?: string | null | undefined, lName?: string | null | undefined, agentId?: number | undefined, typeId?: number | undefined, companyId?: number | null | undefined, marketerAgentId?: number | undefined, notes?: string | null | undefined, isPrivate?: boolean | undefined, createdDate?: Date | undefined, fileData?: string | null | undefined, workflowStatusId?: number | undefined, licenseStatusId?: number | undefined, isWorkflowChecked?: boolean | undefined, isDontSend?: boolean | undefined, ignoreForAgeCalculation?: boolean | undefined, file?: FileParameter | null | undefined, isSendSubmission?: boolean | undefined, submissionTypeIds?: string | null | undefined): Promise<CreateUpdateDocumentResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/CreateDocument";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (fName !== null && fName !== undefined)
            content_.append("FName", fName.toString());
        if (lName !== null && lName !== undefined)
            content_.append("LName", lName.toString());
        if (agentId === null || agentId === undefined)
            throw new Error("The parameter 'agentId' cannot be null.");
        else
            content_.append("AgentId", agentId.toString());
        if (typeId === null || typeId === undefined)
            throw new Error("The parameter 'typeId' cannot be null.");
        else
            content_.append("TypeId", typeId.toString());
        if (companyId !== null && companyId !== undefined)
            content_.append("CompanyId", companyId.toString());
        if (marketerAgentId === null || marketerAgentId === undefined)
            throw new Error("The parameter 'marketerAgentId' cannot be null.");
        else
            content_.append("MarketerAgentId", marketerAgentId.toString());
        if (notes !== null && notes !== undefined)
            content_.append("Notes", notes.toString());
        if (isPrivate === null || isPrivate === undefined)
            throw new Error("The parameter 'isPrivate' cannot be null.");
        else
            content_.append("IsPrivate", isPrivate.toString());
        if (createdDate === null || createdDate === undefined)
            throw new Error("The parameter 'createdDate' cannot be null.");
        else
            content_.append("CreatedDate", createdDate.toJSON());
        if (fileData !== null && fileData !== undefined)
            content_.append("FileData", fileData.toString());
        if (workflowStatusId === null || workflowStatusId === undefined)
            throw new Error("The parameter 'workflowStatusId' cannot be null.");
        else
            content_.append("WorkflowStatusId", workflowStatusId.toString());
        if (licenseStatusId === null || licenseStatusId === undefined)
            throw new Error("The parameter 'licenseStatusId' cannot be null.");
        else
            content_.append("LicenseStatusId", licenseStatusId.toString());
        if (isWorkflowChecked === null || isWorkflowChecked === undefined)
            throw new Error("The parameter 'isWorkflowChecked' cannot be null.");
        else
            content_.append("IsWorkflowChecked", isWorkflowChecked.toString());
        if (isDontSend === null || isDontSend === undefined)
            throw new Error("The parameter 'isDontSend' cannot be null.");
        else
            content_.append("IsDontSend", isDontSend.toString());
        if (ignoreForAgeCalculation === null || ignoreForAgeCalculation === undefined)
            throw new Error("The parameter 'ignoreForAgeCalculation' cannot be null.");
        else
            content_.append("IgnoreForAgeCalculation", ignoreForAgeCalculation.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (isSendSubmission === null || isSendSubmission === undefined)
            throw new Error("The parameter 'isSendSubmission' cannot be null.");
        else
            content_.append("IsSendSubmission", isSendSubmission.toString());
        if (submissionTypeIds !== null && submissionTypeIds !== undefined)
            content_.append("SubmissionTypeIds", submissionTypeIds.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDocument(_response);
        });
    }

    protected processCreateDocument(response: Response): Promise<CreateUpdateDocumentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateUpdateDocumentResponse;
                return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateUpdateDocumentResponse>(null as any);
    }

    /**
     * @param documentId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    editDocument(v: string, documentId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<EditAgentDocumentResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/EditDocument?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditDocument(_response);
        });
    }

    protected processEditDocument(response: Response): Promise<EditAgentDocumentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EditAgentDocumentResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditAgentDocumentResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param id (optional) 
     * @param typeId (optional) 
     * @param companyId (optional) 
     * @param notes (optional) 
     * @param submitToOption (optional) 
     * @param submitToValue (optional) 
     * @param fileType (optional) 
     * @param file (optional) 
     * @param isPrivate (optional) 
     * @param isWorkflowChecked (optional) 
     * @param submissionTypeIds (optional) 
     * @param licenseStatusId (optional) 
     * @param agentId (optional) 
     * @param isSendSubmission (optional) 
     * @param ignoreForAgeCalculation (optional) 
     * @return Success
     */
    updateDocument(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, id?: number | undefined, typeId?: number | undefined, companyId?: number | null | undefined, notes?: string | null | undefined, submitToOption?: number | null | undefined, submitToValue?: string | null | undefined, fileType?: number | undefined, file?: FileParameter | null | undefined, isPrivate?: boolean | undefined, isWorkflowChecked?: boolean | undefined, submissionTypeIds?: string | null | undefined, licenseStatusId?: number | undefined, agentId?: number | undefined, isSendSubmission?: boolean | undefined, ignoreForAgeCalculation?: boolean | undefined): Promise<UpdateDocumentResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/UpdateDocument";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (typeId === null || typeId === undefined)
            throw new Error("The parameter 'typeId' cannot be null.");
        else
            content_.append("TypeId", typeId.toString());
        if (companyId !== null && companyId !== undefined)
            content_.append("CompanyId", companyId.toString());
        if (notes !== null && notes !== undefined)
            content_.append("Notes", notes.toString());
        if (submitToOption !== null && submitToOption !== undefined)
            content_.append("SubmitToOption", submitToOption.toString());
        if (submitToValue !== null && submitToValue !== undefined)
            content_.append("SubmitToValue", submitToValue.toString());
        if (fileType === null || fileType === undefined)
            throw new Error("The parameter 'fileType' cannot be null.");
        else
            content_.append("FileType", fileType.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (isPrivate === null || isPrivate === undefined)
            throw new Error("The parameter 'isPrivate' cannot be null.");
        else
            content_.append("IsPrivate", isPrivate.toString());
        if (isWorkflowChecked === null || isWorkflowChecked === undefined)
            throw new Error("The parameter 'isWorkflowChecked' cannot be null.");
        else
            content_.append("IsWorkflowChecked", isWorkflowChecked.toString());
        if (submissionTypeIds !== null && submissionTypeIds !== undefined)
            content_.append("SubmissionTypeIds", submissionTypeIds.toString());
        if (licenseStatusId === null || licenseStatusId === undefined)
            throw new Error("The parameter 'licenseStatusId' cannot be null.");
        else
            content_.append("LicenseStatusId", licenseStatusId.toString());
        if (agentId === null || agentId === undefined)
            throw new Error("The parameter 'agentId' cannot be null.");
        else
            content_.append("AgentId", agentId.toString());
        if (isSendSubmission === null || isSendSubmission === undefined)
            throw new Error("The parameter 'isSendSubmission' cannot be null.");
        else
            content_.append("IsSendSubmission", isSendSubmission.toString());
        if (ignoreForAgeCalculation === null || ignoreForAgeCalculation === undefined)
            throw new Error("The parameter 'ignoreForAgeCalculation' cannot be null.");
        else
            content_.append("IgnoreForAgeCalculation", ignoreForAgeCalculation.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDocument(_response);
        });
    }

    protected processUpdateDocument(response: Response): Promise<UpdateDocumentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateDocumentResponse;
                return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateDocumentResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param customerId (optional) 
     * @param companyId (optional) 
     * @param typeId (optional) 
     * @param marketerAgentId (optional) 
     * @param notes (optional) 
     * @param policyId (optional) 
     * @param licenseStatusId (optional) 
     * @param isSendAgentEmailChecked (optional) 
     * @param isSendDocViaReSubmitChecked (optional) 
     * @param documentId (optional) 
     * @param file (optional) 
     * @param isSendSubmission (optional) 
     * @param submissionTypeIds (optional) 
     * @param submissionTypeText (optional) 
     * @return Success
     */
    createCustomerDocument(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, customerId?: number | undefined, companyId?: number | null | undefined, typeId?: number | undefined, marketerAgentId?: number | undefined, notes?: string | null | undefined, policyId?: number | null | undefined, licenseStatusId?: number | undefined, isSendAgentEmailChecked?: boolean | undefined, isSendDocViaReSubmitChecked?: boolean | undefined, documentId?: number | undefined, file?: FileParameter | null | undefined, isSendSubmission?: boolean | undefined, submissionTypeIds?: string | null | undefined, submissionTypeText?: string | null | undefined): Promise<CreateCustomerDocumentResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/customerdocument";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (customerId === null || customerId === undefined)
            throw new Error("The parameter 'customerId' cannot be null.");
        else
            content_.append("CustomerId", customerId.toString());
        if (companyId !== null && companyId !== undefined)
            content_.append("CompanyId", companyId.toString());
        if (typeId === null || typeId === undefined)
            throw new Error("The parameter 'typeId' cannot be null.");
        else
            content_.append("TypeId", typeId.toString());
        if (marketerAgentId === null || marketerAgentId === undefined)
            throw new Error("The parameter 'marketerAgentId' cannot be null.");
        else
            content_.append("MarketerAgentId", marketerAgentId.toString());
        if (notes !== null && notes !== undefined)
            content_.append("Notes", notes.toString());
        if (policyId !== null && policyId !== undefined)
            content_.append("PolicyId", policyId.toString());
        if (licenseStatusId === null || licenseStatusId === undefined)
            throw new Error("The parameter 'licenseStatusId' cannot be null.");
        else
            content_.append("LicenseStatusId", licenseStatusId.toString());
        if (isSendAgentEmailChecked === null || isSendAgentEmailChecked === undefined)
            throw new Error("The parameter 'isSendAgentEmailChecked' cannot be null.");
        else
            content_.append("IsSendAgentEmailChecked", isSendAgentEmailChecked.toString());
        if (isSendDocViaReSubmitChecked === null || isSendDocViaReSubmitChecked === undefined)
            throw new Error("The parameter 'isSendDocViaReSubmitChecked' cannot be null.");
        else
            content_.append("IsSendDocViaReSubmitChecked", isSendDocViaReSubmitChecked.toString());
        if (documentId === null || documentId === undefined)
            throw new Error("The parameter 'documentId' cannot be null.");
        else
            content_.append("DocumentId", documentId.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (isSendSubmission === null || isSendSubmission === undefined)
            throw new Error("The parameter 'isSendSubmission' cannot be null.");
        else
            content_.append("IsSendSubmission", isSendSubmission.toString());
        if (submissionTypeIds !== null && submissionTypeIds !== undefined)
            content_.append("SubmissionTypeIds", submissionTypeIds.toString());
        if (submissionTypeText !== null && submissionTypeText !== undefined)
            content_.append("SubmissionTypeText", submissionTypeText.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCustomerDocument(_response);
        });
    }

    protected processCreateCustomerDocument(response: Response): Promise<CreateCustomerDocumentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCustomerDocumentResponse;
                return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCustomerDocumentResponse>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContractDocuments(contractId: number, v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/contracts/{contractId}/documents?";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractDocuments(_response);
        });
    }

    protected processGetContractDocuments(response: Response): Promise<DocumentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCustomerAddDocumentsDetails(customerId: number, policyId: number, docTypeId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CustomerDocumentResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/customer/{customerId}/{policyId}/{docTypeId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (policyId === undefined || policyId === null)
            throw new Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
        if (docTypeId === undefined || docTypeId === null)
            throw new Error("The parameter 'docTypeId' must be defined.");
        url_ = url_.replace("{docTypeId}", encodeURIComponent("" + docTypeId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerAddDocumentsDetails(_response);
        });
    }

    protected processGetCustomerAddDocumentsDetails(response: Response): Promise<CustomerDocumentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerDocumentResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerDocumentResponse>(null as any);
    }

    /**
     * @param documentId (optional) 
     * @param typeId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadPdf(v: string, documentId?: number | undefined, typeId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DownloadPdfModel> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/downloadpdf/documentid/typeId?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadPdf(_response);
        });
    }

    protected processDownloadPdf(response: Response): Promise<DownloadPdfModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadPdfModel;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadPdfModel>(null as any);
    }

    /**
     * @param documentId (optional) 
     * @param typeId (optional) 
     * @param isAgent (optional) 
     * @param isView (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadFiles(v: string, documentId?: number | undefined, typeId?: number | undefined, isAgent?: boolean | undefined, isView?: boolean | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/downloadfiles/documentid/typeId?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        if (isAgent === null)
            throw new Error("The parameter 'isAgent' cannot be null.");
        else if (isAgent !== undefined)
            url_ += "isAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (isView === null)
            throw new Error("The parameter 'isView' cannot be null.");
        else if (isView !== undefined)
            url_ += "isView=" + encodeURIComponent("" + isView) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadFiles(_response);
        });
    }

    protected processDownloadFiles(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fileGuid (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadActionLogFile(v: string, fileGuid?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DownloadPdfModel> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/downloadactionlogfile?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fileGuid !== undefined && fileGuid !== null)
            url_ += "fileGuid=" + encodeURIComponent("" + fileGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadActionLogFile(_response);
        });
    }

    protected processDownloadActionLogFile(response: Response): Promise<DownloadPdfModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadPdfModel;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadPdfModel>(null as any);
    }

    /**
     * @param documentId (optional) 
     * @param documentType (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadCustomerPdf(v: string, documentId?: number | undefined, documentType?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DownloadPdfModel> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/downloadcustomerpdf/documentid?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadCustomerPdf(_response);
        });
    }

    protected processDownloadCustomerPdf(response: Response): Promise<DownloadPdfModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadPdfModel;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadPdfModel>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param typeId (optional) 
     * @param agentId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getWorkflowData(v: string, companyId?: number | undefined, typeId?: number | undefined, agentId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<WorkflowDataResponse[]> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/workflowdata?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkflowData(_response);
        });
    }

    protected processGetWorkflowData(response: Response): Promise<WorkflowDataResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowDataResponse[];
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowDataResponse[]>(null as any);
    }

    /**
     * @param policyId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCustomerWorkflowDocument(v: string, policyId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ScannedDocumentsDataEntryView[]> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/customerworkflowdocument/policyid?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerWorkflowDocument(_response);
        });
    }

    protected processGetCustomerWorkflowDocument(response: Response): Promise<ScannedDocumentsDataEntryView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScannedDocumentsDataEntryView[];
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentDocScreenLookups(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentDocScreenLookupsResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/agentdocscreenlookups";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentDocScreenLookups(_response);
        });
    }

    protected processGetAgentDocScreenLookups(response: Response): Promise<AgentDocScreenLookupsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentDocScreenLookupsResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentDocScreenLookupsResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getSubmissionTypesByCarrierId(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: SubmissionTypesRequest | undefined): Promise<SubmissionTypesResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/submissiontypesbycarrierid";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubmissionTypesByCarrierId(_response);
        });
    }

    protected processGetSubmissionTypesByCarrierId(response: Response): Promise<SubmissionTypesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubmissionTypesResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmissionTypesResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getSubmissionTypesByDocumentId(documentId: number, customerId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/submissiontypesbydocumentId/{documentId}/{customerId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubmissionTypesByDocumentId(_response);
        });
    }

    protected processGetSubmissionTypesByDocumentId(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getDocumentAssocaitionsByDocumentId(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentAssocaitionsResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/documentassocaitionsbydocumentid/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocumentAssocaitionsByDocumentId(_response);
        });
    }

    protected processGetDocumentAssocaitionsByDocumentId(response: Response): Promise<DocumentAssocaitionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentAssocaitionsResponse;
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getFilesSizeById(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: FileRequest | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/documents/getFilesSizeById";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilesSizeById(_response);
        });
    }

    protected processGetFilesSizeById(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllDocumentFileTypes(v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentFileTypesSearchResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/documentfiletype?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllDocumentFileTypes(_response);
        });
    }

    protected processGetAllDocumentFileTypes(response: Response): Promise<DocumentFileTypesSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentFileTypesSearchResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentFileTypesSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    addDocumentFileType(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: DocumentFileTypeModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/document/v{v}/documentfiletype";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddDocumentFileType(_response);
        });
    }

    protected processAddDocumentFileType(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
                return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateDocumentFileType(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: DocumentFileTypeModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/document/v{v}/documentfiletype";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDocumentFileType(_response);
        });
    }

    protected processUpdateDocumentFileType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getDocumentFileTypeById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentFileTypeModel> {
        let url_ = this.baseUrl + "/api/document/v{v}/documentfiletype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocumentFileTypeById(_response);
        });
    }

    protected processGetDocumentFileTypeById(response: Response): Promise<DocumentFileTypeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentFileTypeModel;
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteDocumentFileType(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/document/v{v}/documentfiletype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDocumentFileType(_response);
        });
    }

    protected processDeleteDocumentFileType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getDocumentFileTypesLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/document/v{v}/documentfiletype/lookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocumentFileTypesLookup(_response);
        });
    }

    protected processGetDocumentFileTypesLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getDocumentAllFileTypesLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/document/v{v}/documentfiletype/DocumentAllFileTypesLookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocumentAllFileTypesLookup(_response);
        });
    }

    protected processGetDocumentAllFileTypesLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param categoryId (optional) 
     * @param carrierId (optional) 
     * @param carrierGroupId (optional) 
     * @param stateId (optional) 
     * @param productId (optional) 
     * @param productSubCategoryId (optional) 
     * @param payLayoutId (optional) 
     * @param agencyId (optional) 
     * @param documentTypeId (optional) 
     * @param title (optional) 
     * @param isIncludeInactiveCarrier (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllManageDocument(v: string, categoryId?: number | undefined, carrierId?: number | undefined, carrierGroupId?: number | undefined, stateId?: number | undefined, productId?: number | undefined, productSubCategoryId?: number | undefined, payLayoutId?: number | undefined, agencyId?: number | undefined, documentTypeId?: string | null | undefined, title?: string | null | undefined, isIncludeInactiveCarrier?: boolean | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentsSearchResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/manage?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (carrierId === null)
            throw new Error("The parameter 'carrierId' cannot be null.");
        else if (carrierId !== undefined)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (carrierGroupId === null)
            throw new Error("The parameter 'carrierGroupId' cannot be null.");
        else if (carrierGroupId !== undefined)
            url_ += "CarrierGroupId=" + encodeURIComponent("" + carrierGroupId) + "&";
        if (stateId === null)
            throw new Error("The parameter 'stateId' cannot be null.");
        else if (stateId !== undefined)
            url_ += "StateId=" + encodeURIComponent("" + stateId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (productSubCategoryId === null)
            throw new Error("The parameter 'productSubCategoryId' cannot be null.");
        else if (productSubCategoryId !== undefined)
            url_ += "ProductSubCategoryId=" + encodeURIComponent("" + productSubCategoryId) + "&";
        if (payLayoutId === null)
            throw new Error("The parameter 'payLayoutId' cannot be null.");
        else if (payLayoutId !== undefined)
            url_ += "PayLayoutId=" + encodeURIComponent("" + payLayoutId) + "&";
        if (agencyId === null)
            throw new Error("The parameter 'agencyId' cannot be null.");
        else if (agencyId !== undefined)
            url_ += "AgencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (documentTypeId !== undefined && documentTypeId !== null)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (title !== undefined && title !== null)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (isIncludeInactiveCarrier === null)
            throw new Error("The parameter 'isIncludeInactiveCarrier' cannot be null.");
        else if (isIncludeInactiveCarrier !== undefined)
            url_ += "IsIncludeInactiveCarrier=" + encodeURIComponent("" + isIncludeInactiveCarrier) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllManageDocument(_response);
        });
    }

    protected processGetAllManageDocument(response: Response): Promise<DocumentsSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentsSearchResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentsSearchResponse>(null as any);
    }

    /**
     * @param categoryId (optional) 
     * @param carrierId (optional) 
     * @param carrierGroupId (optional) 
     * @param stateId (optional) 
     * @param productId (optional) 
     * @param productSubCategoryId (optional) 
     * @param payoutLayoutId (optional) 
     * @param agencyId (optional) 
     * @param documentTypeId (optional) 
     * @param title (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllDocumentPackets(v: string, categoryId?: number | undefined, carrierId?: number | undefined, carrierGroupId?: number | undefined, stateId?: number | undefined, productId?: number | undefined, productSubCategoryId?: number | undefined, payoutLayoutId?: number | undefined, agencyId?: number | undefined, documentTypeId?: number[] | null | undefined, title?: string | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentPacketSearchResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/manage/documentpackets?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (carrierId === null)
            throw new Error("The parameter 'carrierId' cannot be null.");
        else if (carrierId !== undefined)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (carrierGroupId === null)
            throw new Error("The parameter 'carrierGroupId' cannot be null.");
        else if (carrierGroupId !== undefined)
            url_ += "CarrierGroupId=" + encodeURIComponent("" + carrierGroupId) + "&";
        if (stateId === null)
            throw new Error("The parameter 'stateId' cannot be null.");
        else if (stateId !== undefined)
            url_ += "StateId=" + encodeURIComponent("" + stateId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (productSubCategoryId === null)
            throw new Error("The parameter 'productSubCategoryId' cannot be null.");
        else if (productSubCategoryId !== undefined)
            url_ += "ProductSubCategoryId=" + encodeURIComponent("" + productSubCategoryId) + "&";
        if (payoutLayoutId === null)
            throw new Error("The parameter 'payoutLayoutId' cannot be null.");
        else if (payoutLayoutId !== undefined)
            url_ += "PayoutLayoutId=" + encodeURIComponent("" + payoutLayoutId) + "&";
        if (agencyId === null)
            throw new Error("The parameter 'agencyId' cannot be null.");
        else if (agencyId !== undefined)
            url_ += "AgencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (documentTypeId !== undefined && documentTypeId !== null)
            documentTypeId && documentTypeId.forEach(item => { url_ += "DocumentTypeId=" + encodeURIComponent("" + item) + "&"; });
        if (title !== undefined && title !== null)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllDocumentPackets(_response);
        });
    }

    protected processGetAllDocumentPackets(response: Response): Promise<DocumentPacketSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentPacketSearchResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentPacketSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getDocumentByPacketId(packetid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentsSearchResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/manage/documentdetails/{packetid}";
        if (packetid === undefined || packetid === null)
            throw new Error("The parameter 'packetid' must be defined.");
        url_ = url_.replace("{packetid}", encodeURIComponent("" + packetid));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocumentByPacketId(_response);
        });
    }

    protected processGetDocumentByPacketId(response: Response): Promise<DocumentsSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentsSearchResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentsSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllManageDocumentLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentsLookupModel2> {
        let url_ = this.baseUrl + "/api/document/v{v}/manage/lookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllManageDocumentLookup(_response);
        });
    }

    protected processGetAllManageDocumentLookup(response: Response): Promise<DocumentsLookupModel2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentsLookupModel2;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentsLookupModel2>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getDocumentTypeByGroupId(groupid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentTypesModel> {
        let url_ = this.baseUrl + "/api/document/v{v}/manage/documenttypes/{groupid}";
        if (groupid === undefined || groupid === null)
            throw new Error("The parameter 'groupid' must be defined.");
        url_ = url_.replace("{groupid}", encodeURIComponent("" + groupid));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocumentTypeByGroupId(_response);
        });
    }

    protected processGetDocumentTypeByGroupId(response: Response): Promise<DocumentTypesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTypesModel;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTypesModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCompanybyCompanyGroupId(companygroupid: number, includeInactive: boolean | undefined, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<LookupByCompanyIdModel> {
        let url_ = this.baseUrl + "/api/document/v{v}/manage/{companygroupid}/companies/{includeInactive}";
        if (companygroupid === undefined || companygroupid === null)
            throw new Error("The parameter 'companygroupid' must be defined.");
        url_ = url_.replace("{companygroupid}", encodeURIComponent("" + companygroupid));
        if (includeInactive === undefined || includeInactive === null)
            throw new Error("The parameter 'includeInactive' must be defined.");
        url_ = url_.replace("{includeInactive}", encodeURIComponent("" + includeInactive));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCompanybyCompanyGroupId(_response);
        });
    }

    protected processGetAllCompanybyCompanyGroupId(response: Response): Promise<LookupByCompanyIdModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookupByCompanyIdModel;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupByCompanyIdModel>(null as any);
    }

    /**
     * @param carrierId (optional) 
     * @param carrierGroupId (optional) 
     * @param productSubCategoryId (optional) 
     * @param fromSearch (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllLookupbyCompany(v: string, carrierId?: number | undefined, carrierGroupId?: number | undefined, productSubCategoryId?: number | undefined, fromSearch?: boolean | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<LookupByCompanyIdModel> {
        let url_ = this.baseUrl + "/api/document/v{v}/manage/lookupbycompany?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (carrierId === null)
            throw new Error("The parameter 'carrierId' cannot be null.");
        else if (carrierId !== undefined)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (carrierGroupId === null)
            throw new Error("The parameter 'carrierGroupId' cannot be null.");
        else if (carrierGroupId !== undefined)
            url_ += "CarrierGroupId=" + encodeURIComponent("" + carrierGroupId) + "&";
        if (productSubCategoryId === null)
            throw new Error("The parameter 'productSubCategoryId' cannot be null.");
        else if (productSubCategoryId !== undefined)
            url_ += "ProductSubCategoryId=" + encodeURIComponent("" + productSubCategoryId) + "&";
        if (fromSearch === null)
            throw new Error("The parameter 'fromSearch' cannot be null.");
        else if (fromSearch !== undefined)
            url_ += "FromSearch=" + encodeURIComponent("" + fromSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllLookupbyCompany(_response);
        });
    }

    protected processGetAllLookupbyCompany(response: Response): Promise<LookupByCompanyIdModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookupByCompanyIdModel;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupByCompanyIdModel>(null as any);
    }

    /**
     * @param carrierId (optional) 
     * @param carrierGroupId (optional) 
     * @param productSubCategoryId (optional) 
     * @param fromSearch (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllProductsbyProductSubCategoryId(v: string, carrierId?: number | undefined, carrierGroupId?: number | undefined, productSubCategoryId?: number | undefined, fromSearch?: boolean | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ProductsByProductSubCategoryResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/manage/productsbyproductsubcategory?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (carrierId === null)
            throw new Error("The parameter 'carrierId' cannot be null.");
        else if (carrierId !== undefined)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (carrierGroupId === null)
            throw new Error("The parameter 'carrierGroupId' cannot be null.");
        else if (carrierGroupId !== undefined)
            url_ += "CarrierGroupId=" + encodeURIComponent("" + carrierGroupId) + "&";
        if (productSubCategoryId === null)
            throw new Error("The parameter 'productSubCategoryId' cannot be null.");
        else if (productSubCategoryId !== undefined)
            url_ += "ProductSubCategoryId=" + encodeURIComponent("" + productSubCategoryId) + "&";
        if (fromSearch === null)
            throw new Error("The parameter 'fromSearch' cannot be null.");
        else if (fromSearch !== undefined)
            url_ += "FromSearch=" + encodeURIComponent("" + fromSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllProductsbyProductSubCategoryId(_response);
        });
    }

    protected processGetAllProductsbyProductSubCategoryId(response: Response): Promise<ProductsByProductSubCategoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsByProductSubCategoryResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductsByProductSubCategoryResponse>(null as any);
    }

    /**
     * @param packetId (optional) 
     * @param documentIds (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadBundlePdf(v: string, packetId?: number | undefined, documentIds?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DownloadPdfModel> {
        let url_ = this.baseUrl + "/api/document/v{v}/manage/downloadbundlepdf?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (packetId === null)
            throw new Error("The parameter 'packetId' cannot be null.");
        else if (packetId !== undefined)
            url_ += "PacketId=" + encodeURIComponent("" + packetId) + "&";
        if (documentIds !== undefined && documentIds !== null)
            url_ += "DocumentIds=" + encodeURIComponent("" + documentIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadBundlePdf(_response);
        });
    }

    protected processDownloadBundlePdf(response: Response): Promise<DownloadPdfModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadPdfModel;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadPdfModel>(null as any);
    }

    /**
     * @param packetId (optional) 
     * @param documentIds (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadSignaturePages(v: string, packetId?: number | undefined, documentIds?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DownloadPdfModel> {
        let url_ = this.baseUrl + "/api/document/v{v}/manage/downloadsignaturepages?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (packetId === null)
            throw new Error("The parameter 'packetId' cannot be null.");
        else if (packetId !== undefined)
            url_ += "PacketId=" + encodeURIComponent("" + packetId) + "&";
        if (documentIds !== undefined && documentIds !== null)
            url_ += "DocumentIds=" + encodeURIComponent("" + documentIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadSignaturePages(_response);
        });
    }

    protected processDownloadSignaturePages(response: Response): Promise<DownloadPdfModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadPdfModel;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadPdfModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    sendDocumentEmail(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: SendEmailRequestModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/document/v{v}/manage/sendemail";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendDocumentEmail(_response);
        });
    }

    protected processSendDocumentEmail(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
                return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadManagePdf(documentid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DownloadPdfModel> {
        let url_ = this.baseUrl + "/api/document/v{v}/manage/viewdocument/{documentid}";
        if (documentid === undefined || documentid === null)
            throw new Error("The parameter 'documentid' must be defined.");
        url_ = url_.replace("{documentid}", encodeURIComponent("" + documentid));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadManagePdf(_response);
        });
    }

    protected processDownloadManagePdf(response: Response): Promise<DownloadPdfModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadPdfModel;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadPdfModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getDocumentsByCompanyPacketId(packetid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DocumentsSearchByTypeResponse> {
        let url_ = this.baseUrl + "/api/document/v{v}/manage/documentdetailsbypacket/{packetid}";
        if (packetid === undefined || packetid === null)
            throw new Error("The parameter 'packetid' must be defined.");
        url_ = url_.replace("{packetid}", encodeURIComponent("" + packetid));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocumentsByCompanyPacketId(_response);
        });
    }

    protected processGetDocumentsByCompanyPacketId(response: Response): Promise<DocumentsSearchByTypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentsSearchByTypeResponse;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentsSearchByTypeResponse>(null as any);
    }

    /**
     * @param packetId (optional) 
     * @param documentId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadDocumentByPacketAsZip(v: string, packetId?: number | undefined, documentId?: number[] | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/document/v{v}/manage/downloaddocumentbypacketaszip?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (packetId === null)
            throw new Error("The parameter 'packetId' cannot be null.");
        else if (packetId !== undefined)
            url_ += "PacketId=" + encodeURIComponent("" + packetId) + "&";
        if (documentId !== undefined && documentId !== null)
            documentId && documentId.forEach(item => { url_ += "DocumentId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadDocumentByPacketAsZip(_response);
        });
    }

    protected processDownloadDocumentByPacketAsZip(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param agentId (optional) 
     * @param uplineAgentId (optional) 
     * @param marketerIds (optional) 
     * @param companyId (optional) 
     * @param startDate (optional) 
     * @param stopDate (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContractInvites(v: string, agentId?: number | undefined, uplineAgentId?: number | undefined, marketerIds?: string | null | undefined, companyId?: number | undefined, startDate?: Date | undefined, stopDate?: Date | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ContractInviteResponse[]> {
        let url_ = this.baseUrl + "/api/document/v{v}/Report/contractinvite?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (uplineAgentId === null)
            throw new Error("The parameter 'uplineAgentId' cannot be null.");
        else if (uplineAgentId !== undefined)
            url_ += "UplineAgentId=" + encodeURIComponent("" + uplineAgentId) + "&";
        if (marketerIds !== undefined && marketerIds !== null)
            url_ += "MarketerIds=" + encodeURIComponent("" + marketerIds) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (stopDate === null)
            throw new Error("The parameter 'stopDate' cannot be null.");
        else if (stopDate !== undefined)
            url_ += "StopDate=" + encodeURIComponent(stopDate ? "" + stopDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractInvites(_response);
        });
    }

    protected processGetContractInvites(response: Response): Promise<ContractInviteResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractInviteResponse[];
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractInviteResponse[]>(null as any);
    }
}

export interface DocumentList {
    id?: number;
    description?: string | undefined;
    title?: string | undefined;
    fileName?: string | undefined;
    company?: string | undefined;
    companyId?: number;
    productId?: number;
    documentTypeId?: number;
    documentType?: string | undefined;
}

export interface DocumentsSearchResponse {
    recordCount?: number;
    emailAllRecords?: DocumentList[] | undefined;
    data?: DocumentList[] | undefined;
    packetSignatureAvailable?: boolean;
}

export interface ListItem {
    value?: string | undefined;
    text?: string | undefined;
    selected?: boolean;
}

export interface DocumentByIdResponse {
    readonly id?: number;
    readonly title?: string | undefined;
    readonly description?: string | undefined;
    readonly companyList?: ListItem[] | undefined;
    readonly companyId?: number;
    readonly productId?: number;
    readonly productList?: ListItem[] | undefined;
    readonly typeList?: ListItem[] | undefined;
    readonly typeId?: number;
    readonly file?: string | undefined;
    readonly created?: Date;
    readonly replaced?: Date | undefined;
    readonly agentPortalPagesList?: ListItem[] | undefined;
    showOnAgentPortal?: boolean;
    agentPortalPageID?: number | undefined;
    agentPortalYear?: number | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface DocumentsLookupModel {
    documentTypeGroups?: ListItem[] | undefined;
    documentTypes?: ListItem[] | undefined;
    carriers?: ListItem[] | undefined;
    products?: ListItem[] | undefined;
}

export interface DocumentsList {
    readonly id?: number;
    readonly title?: string | undefined;
    readonly description?: string | undefined;
    readonly company?: string | undefined;
    readonly product?: string | undefined;
    readonly type?: string | undefined;
    readonly file?: string | undefined;
    readonly created?: Date;
    readonly replaced?: Date | undefined;
}

export interface ArchivedDocumentResponse {
    recordCount?: number;
    emailAllRecords?: DocumentsList[] | undefined;
    data?: DocumentsList[] | undefined;
}

export interface DocumentsList2 {
    id?: number;
    description?: string | undefined;
    title?: string | undefined;
    company?: string | undefined;
    product?: string | undefined;
    documentTypeId?: number;
    type?: string | undefined;
}

export interface DocumentsSearchByTypeResponse {
    recordCount?: number;
    emailAllRecords?: DocumentsList2[] | undefined;
    data?: DocumentsList2[] | undefined;
    packetSignatureAvailable?: boolean;
}

export interface DocumentPacketList {
    id?: number;
    documentType?: string | undefined;
    carrier?: string | undefined;
    description?: string | undefined;
    packetName?: string | undefined;
}

export interface PacketSearchResponse {
    recordCount?: number;
    emailAllRecords?: DocumentPacketList[] | undefined;
    data?: DocumentPacketList[] | undefined;
}

export interface DocumentList2 {
    id?: number;
    company?: string | undefined;
    documentTitle?: string | undefined;
    documentType?: string | undefined;
    sortOrder?: number;
    readonly description?: string | undefined;
}

export interface CreateUpdatePacketRequest {
    documentPacketId?: number;
    documentPacketGroupId?: number | undefined;
    packetName?: string | undefined;
    description?: string | undefined;
    companyId?: number;
    payoutLevelId?: number | undefined;
    signaturePageDocumentId?: number | undefined;
    selectedStates?: number[] | undefined;
    selectedProducts?: number[] | undefined;
    packetDocuments?: DocumentList2[] | undefined;
}

export interface StateListItem {
    stateId?: number;
    stateName?: string | undefined;
    abbreviation?: string | undefined;
    selected?: boolean;
    isHeader?: boolean;
}

export interface PacketByIdResponse {
    documentPacketId?: number;
    documentPacketGroupId?: number | undefined;
    packetName?: string | undefined;
    description?: string | undefined;
    companyId?: number;
    payoutLevelId?: number | undefined;
    signaturePageDocumentId?: number | undefined;
    documentTypeGroupList?: ListItem[] | undefined;
    carrierList?: ListItem[] | undefined;
    levelList?: ListItem[] | undefined;
    signaturePageDocsList?: ListItem[] | undefined;
    productList?: ListItem[] | undefined;
    stateList?: StateListItem[] | undefined;
    selectedStates?: ListItem[] | undefined;
    selectedProducts?: ListItem[] | undefined;
    packetDocuments?: DocumentList2[] | undefined;
}

export interface PacketLookupModel {
    documentTypeGroups?: ListItem[] | undefined;
    carriers?: ListItem[] | undefined;
}

export interface PacketDocumentRespose {
    recordCount?: number;
    emailAllRecords?: DocumentList2[] | undefined;
    data?: DocumentList2[] | undefined;
}

export interface LookupByCompanyResponse {
    payoutLayouts?: ListItem[] | undefined;
    signaturePageDocs?: ListItem[] | undefined;
}

export interface DocumentListModel {
    id?: number;
    createdDate?: Date;
    companyName?: string | undefined;
    fileType?: string | undefined;
    documentName?: string | undefined;
    notes?: string | undefined;
    workFlow?: string | undefined;
    private?: boolean;
    extension?: string | undefined;
    isCreatedUser?: boolean;
    hasWorkFlowNotes?: boolean;
}

export interface DocumentSearchRepsonse {
    recordCount?: number;
    emailAllRecords?: DocumentListModel[] | undefined;
    data?: DocumentListModel[] | undefined;
}

export interface WorkflowList {
    id?: number;
    name?: string | undefined;
}

export interface DocumentDetailModel {
    id?: number;
    createdDate?: Date;
    companyName?: string | undefined;
    fileType?: string | undefined;
    notes?: string | undefined;
    workFlow?: string | undefined;
    filename?: string | undefined;
    marketerAgentId?: number | undefined;
    uplineAgentId?: number | undefined;
    companyList?: ListItem[] | undefined;
    documentTypeList?: ListItem[] | undefined;
    workflowList?: WorkflowList[] | undefined;
}

export interface CustomerDocumentSearchListModel {
    id?: number;
    companyName?: string | undefined;
    companyId?: number | undefined;
    policyId?: number | undefined;
    policyNumbers?: string | undefined;
    fileType?: string | undefined;
    notes?: string | undefined;
    ftp?: boolean;
    fax?: boolean;
    createdDate?: Date;
    canResubmitDocument?: boolean;
    fileName?: string | undefined;
}

export interface CustomerDocumentSearchResponse {
    recordCount?: number;
    emailAllRecords?: CustomerDocumentSearchListModel[] | undefined;
    data?: CustomerDocumentSearchListModel[] | undefined;
}

export interface CreateUpdateDocumentResponse {
    id?: number;
    message?: string | undefined;
}

export interface WorkflowDataResponse {
    id?: number;
    name?: string | undefined;
}

export interface EditAgentDocumentResponse {
    id?: number;
    typeId?: number;
    agentId?: number | undefined;
    companyId?: number | undefined;
    notes?: string | undefined;
    fileBytes?: string | undefined;
    fileName?: string | undefined;
    fileType?: number;
    guid?: string;
    private?: boolean;
    submitToOption?: number | undefined;
    submitToValue?: string | undefined;
    companyList?: ListItem[] | undefined;
    submissionTypes?: ListItem[] | undefined;
    documentTypeList?: ListItem[] | undefined;
    workflowList?: WorkflowDataResponse[] | undefined;
}

export interface UpdateDocumentResponse {
    id?: number;
    message?: string | undefined;
}

export interface CreateCustomerDocumentResponse {
    message?: string | undefined;
}

export interface ContractDocumentDetailModel {
    documentId?: number;
    date?: Date;
    type?: string | undefined;
    carrier?: string | undefined;
    notes?: string | undefined;
    extension?: string | undefined;
    convertedDate?: Date;
}

export interface DocumentResponse {
    recordCount?: number;
    emailAllRecords?: ContractDocumentDetailModel[] | undefined;
    data?: ContractDocumentDetailModel[] | undefined;
}

export interface ListFaxNumber {
    id?: number;
    faxNumber?: string | undefined;
    faxNumberDisplay?: string | undefined;
}

export interface ScannedDocumentsDataEntryView {
    id?: number;
    name?: string | undefined;
}

export interface CustomerScannedDocumentPolicyView {
    policyID?: number;
    name?: string | undefined;
}

export interface CompanyList {
    id?: number;
    name?: string | undefined;
}

export interface FileTypeList {
    id?: number;
    name?: string | undefined;
}

export interface CustomerDocumentResponse {
    chkFTP?: boolean;
    chkFax?: boolean;
    chkFTPEnabled?: boolean;
    chkFaxEnabled?: boolean;
    faxDeliveryDateVisible?: boolean;
    delayFaxDateTitleVisible?: boolean;
    companyIdSelected?: number;
    faxNumberSelected?: number;
    documentTypeSelected?: number;
    companyFaxNumber?: ListFaxNumber[] | undefined;
    scannedDocumentsDataList?: ScannedDocumentsDataEntryView[] | undefined;
    policyList?: CustomerScannedDocumentPolicyView[] | undefined;
    companyList?: CompanyList[] | undefined;
    fileTypeList?: FileTypeList[] | undefined;
}

export interface DownloadPdfModel {
    pdfData?: string | undefined;
    message?: string | undefined;
    fileName?: string | undefined;
    actualFileName?: string | undefined;
    fileContent?: string | undefined;
    mimeType?: string | undefined;
}

export interface AgentDocScreenLookupsResponse {
    fileTypes?: ListItem[] | undefined;
    carriers?: ListItem[] | undefined;
}

export interface SubmissionTypesRequest {
    policyId?: number;
    typeId?: number;
    customerId?: number;
}

export interface SubmissionTypesResponse {
    submissionList?: ListItem[] | undefined;
    isSubmissionChecked?: boolean;
    isSubmissionEnabled?: boolean;
}

export interface DocumentAssocaitionsResponse {
    message?: string | undefined;
}

export interface FileRequest {
    documentId?: number;
    documentType?: number;
}

export interface FileResponse {
    documentFileSize?: number;
}

export interface DocumentFileTypesListModel {
    id?: number;
    fileType?: string | undefined;
    isHierarchyRequired?: boolean;
    isInsured?: boolean;
}

export interface DocumentFileTypesSearchResponse {
    recordCount?: number;
    emailAllRecords?: DocumentFileTypesListModel[] | undefined;
    data?: DocumentFileTypesListModel[] | undefined;
}

export interface DocumentFileTypeModel {
    id?: number | undefined;
    type?: string | undefined;
    isHierarchyRequired?: boolean;
    isInsured?: boolean;
}

export interface DocumentPacketList2 {
    id?: number;
    packetName?: string | undefined;
    description?: string | undefined;
    companyId?: number;
    company?: string | undefined;
    productId?: number;
    products?: string | undefined;
    stateId?: number;
    states?: string | undefined;
    stateIds?: number[] | undefined;
    productIds?: number[] | undefined;
    productSubCategoryIds?: number[] | undefined;
    groupId?: number;
    payoutLevelID?: number | undefined;
    signaturePageDocumentID?: number;
}

export interface DocumentPacketSearchResponse {
    recordCount?: number;
    emailAllRecords?: DocumentPacketList2[] | undefined;
    data?: DocumentPacketList2[] | undefined;
}

export interface DocumentsLookupModel2 {
    categories?: ListItem[] | undefined;
    carriers?: ListItem[] | undefined;
    carrierGroups?: ListItem[] | undefined;
    states?: StateListItem[] | undefined;
    products?: ListItem[] | undefined;
    productSubCategories?: ListItem[] | undefined;
    documentTypes?: ListItem[] | undefined;
}

export interface DocumentTypesModel {
    documentTypes?: ListItem[] | undefined;
}

export interface LookupByCompanyIdModel {
    carriers?: ListItem[] | undefined;
    products?: ListItem[] | undefined;
    payoutLayouts?: ListItem[] | undefined;
}

export interface ProductsByProductSubCategoryResponse {
    products?: ListItem[] | undefined;
}

export interface SendEmailRequestModel {
    packetId?: number;
    documentIds?: string | undefined;
    agentId?: number;
    companyId?: number;
    toEmails?: string | undefined;
    ccEmails?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    specialInstructions?: string | undefined;
    isSavetoAgentNote?: boolean;
    bundlePdfs?: boolean;
    bundleName?: string | undefined;
    includeSignaturePages?: boolean;
    uplineAgentId?: number;
    groupId?: number;
    dnCall?: boolean;
    dnEmail?: boolean;
    dnMarket?: boolean;
    downlineDNCall?: boolean;
    downlineDNEmail?: boolean;
    downlineDNMarket?: boolean;
}

export interface ReportFile {
    title?: string | undefined;
    data?: string | undefined;
    contentType?: string | undefined;
    fileName?: string | undefined;
}

export interface ContractInviteResponse {
    agentId?: number;
    uplineAgentId?: number;
    marketerAgentId?: number;
    agentName?: string | undefined;
    uplineAgentName?: string | undefined;
    marketerAgentName?: string | undefined;
    companyName?: string | undefined;
    attachedDateTime?: Date;
    workFlowStatus?: string | undefined;
    dateCreated?: Date;
    companyId?: number;
    latestWorkFlowLogId?: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}